






import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({
})
export default class Tooltip extends Vue {
    @Prop({ default: false }) readonly showTooltip!: boolean;
}

